import { useMemo } from "react";
import { renderTemplateUtil } from "shared/components/template/renderTemplateUtil";
import { type FormView } from "shared/mappers/database/form/form";

export const useSurveyJSFormDesignOverrideTemplates = ({
  overrideTitleTemplate,
  overrideDescriptionTemplate,
  overrideCompleteButtonTextTemplate,
  form,
  templateData,
}: {
  overrideTitleTemplate?: string;
  overrideDescriptionTemplate?: string;
  overrideCompleteButtonTextTemplate?: string;
  form?: FormView | null;
  templateData: any;
}) => {
  const overrideTitle = useMemo(
    () =>
      renderTemplateUtil({
        template: overrideTitleTemplate ?? form?.formDesign?.title ?? "",
        templateData,
      }),
    [overrideTitleTemplate, form?.formDesign?.title],
  );
  const overrideDescription = useMemo(
    () =>
      renderTemplateUtil({
        template:
          overrideDescriptionTemplate ?? form?.formDesign?.description ?? "",
        templateData,
      }),
    [overrideDescriptionTemplate, form?.formDesign?.description],
  );
  const overrideCompleteButtonText = useMemo(
    () =>
      renderTemplateUtil({
        template:
          overrideCompleteButtonTextTemplate ??
          form?.formDesign?.completeButtonText ??
          "Complete",
        templateData,
      }),
    [overrideCompleteButtonTextTemplate, form?.formDesign?.completeButtonText],
  );
  return {
    overrideCompleteButtonText,
    overrideDescription,
    overrideTitle,
  };
};
